export enum LANGUAGES {
  ru = 'ru',
  en = 'en',
}

export const LOCKED_LANG = window._env_.REACT_APP_LOCKED_LANGUAGE || import.meta.env.VITE_LOCKED_LANGUAGE;
